var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 18 18","fill":"currentColor","stroke":"currentColor"}},[_c('polygon',{attrs:{"points":"7 11 9 13 11 11 7 11"}}),_c('polygon',{attrs:{"points":"7 7 9 5 11 7 7 7"}})])}
var staticRenderFns = []

export { render, staticRenderFns }